/*
 * Login functionality
 *
 * login.init(form) converts a login form to ajax and takes care of all the processing from there,
 * calling LoginPlayerJSON and showing playerinfobox on login etc.
 *
 * Will convert links with class="loginbutton" to submit the form on click
 *
 * For pages needing reload, add a function pageLoginHandler to do that, otherwise login box will just be replaced by player info box
 *
 */

/*global security */
define('all/player/login',['jquery', 'all/dialog', 'all/player/new-customer', 'all/player/session', 'all/player/playerinfo', 'all/slidingContentWrapper', 'realityCheck', 'all/jquery/jquery.form'],
	function ($, dialog, nc, session, playerinfo, slidingContentWrapper, realityCheck) {
    'use strict';

    var submitting = false;

    var $playerBar = $('#cnt-player-bar');
    var $loginBar = $('#cnt-login-bar');

    function validateCaptchaIfEnabled(form) {
        var value = $.cookie('0bf04cf90ac495ebce851f21d27d92de3792aaf32b67728b0ab35c7a5d');
        if (value === '49d54f8eca97d64b06a4da452das0c26ad62930b615ab795ba2cd136d3') {
            grecaptcha.execute();
        } else {
        	//if captcha is not enabled for whitelisted countries then we will do a direct login
			submitFormAfterValidation(form);
		}
    }

    window.captchaSubmit = function(token) {
		var isLoginBox = window.isLoginBox || false;
		$.cookie("captcha", token);
		if (isLoginBox) {
			window.captchaSubmitLoginBox();
		} else {
			submitFormAfterValidation($('#loginhtmlform'));
		}
	};

    function closeDialogs() {
        // TODO: remove all traces of modalPanel that could be involved here
        if (typeof (window.modalPanel) !== 'undefined' && window.modalPanel !== null) {
            window.modalPanel.hide();
        }

        dialog.closeAll();
    }

    function doLogin(response, onSuccess) {
        if ($loginBar.find('#rememberusername').not(':checked').length > 0) {
            var $userField = $loginBar.find('#loginusername');
            $userField.val('');
            showHideLabel($userField);
        }
        var $passwordField = $loginBar.find('#loginpassword');
        $passwordField.val('');
        showHideLabel($passwordField);


        setCustomer();
        closeDialogs();

        // show maintenance message if maintenance is coming soon
        if (response.MAINTENANCE) {
            dialog.load('info', {
                title: response.HEADER_MAINTENANCE,
                heading: response.IN_HEADER,
                message: response.IN_MESSAGE
            });
        }

        $('#clock').data('offset', response.PARAM_TIME_ZONE);

        onSuccess();

        var info = response.PARAM_PLAYER_INFO;

        if (typeof (info) !== 'undefined') {
            // TODO: cleanup this init
            playerinfo.init(info);
            session.login();
        } else {
            console.error('login.doLogin', 'PARAM_PLAYER_INFO is undefined');
        }
    }

    function failLogin(response) {
        if ('SYSTEM_ERROR' === response.RESULT) {
            if (typeof (window.modalPanel) !== 'undefined' && window.modalPanel !== null) {
                window.modalPanel.hide();
            }
            window.showSystemError(response.ERROR_HEADER, response.ERROR,
                response.BUTTON_TEXT);
            return;
        }

        if (response.ACC_LOCKED_STATUS) {
            // CLOSED_USER_REQUEST (3), CLOSED_RES_GAMING (6), CLOSED_UK_NOT_RES_GAMING(8)
            if ('3' === response.ACC_LOCKED_STATUS || '6' === response.ACC_LOCKED_STATUS || '8' === response.ACC_LOCKED_STATUS
				|| '11' === response.ACC_LOCKED_STATUS) {
                window.showInfoMessageGeneric(response.POPUP_BODY, true, null, null,
                    response.LOGIN_FAIL_RESP_GAMING_HEADER);
            } else {
                window.showInfoMessage(response.ERROR_HEADER, response.ERROR,
                    response.BUTTON_TEXT, true, null, null,
                    response.LOGIN_FAIL_PANEL_HEADER);
            }
        } else {
            window.showInfoMessage(response.ERROR_HEADER, response.ERROR,
                response.BUTTON_TEXT, true, null, null,
                response.LOGIN_FAIL_PANEL_HEADER);
        }
    }

    // needs pw.js for the function calls
    function mustChangePassword(response) {
        if ('1' === response.PARAM_LOGIN_METHOD) {
            if ('true' === response.PARAM_MUST_CHANGE_PW) {
				slidingContentWrapper.showSlidingChangePassword();
            } else {
                window.emailCode();
            }
            return true;
        }

        if ('2' === response.PARAM_LOGIN_METHOD) {
            if ('true' === response.PARAM_MUST_CHANGE_PW) {
				slidingContentWrapper.showSlidingChangePassword();
            } else {
                window.smsCode();
            }
            return true;
        }

        if ('true' === response.PARAM_MUST_CHANGE_PW) {
			slidingContentWrapper.showSlidingChangePassword();
            return true;
        }
        return false;
    }

    // login callback
    function ajaxSuccess(json, statusText, xhr, $form) {
        console.log('login.ajaxSuccess', json);
        if (json.RESULT === 'OK') {
			realityCheck.startRealityCheck();
			if(json.HAVE_NOT_SEEN_POPUP) {
				showTCPopup(json);
			} else if(!mustChangePassword(json)) {
				doLogin(json, $form.data('onSuccess'));
			}
        } else {
             failLogin(json);
        }
		grecaptcha.reset();
		$.removeCookie("captcha");
		submitDone();
    }

    function showTCPopup(response) {
        var data = {
            heading: response.TERMS_UPDATED_HEADER,
            message: response.TERMS_UPDATED,
            confirm: response.AGREE,
            username: response.PARAM_USER_NAME,
            password: response.PARAM_PASSWORD,
			captcha: $.cookie ("captcha"),
			rememberme: true,
            termsagreed: true
        };
        dialog.load('TermsAndConditions', data, undefined, undefined);
    }

    // login error callback
    function ajaxError(jqXHR, textStatus, e) {
        dialog.load('error');
        console.error('login.ajaxError', jqXHR, textStatus, e);
		grecaptcha.reset();
		$.removeCookie("captcha");
        submitDone();
    }

    // update the form before send
    function preProcess($form) {

        // flash version is used for comment in session, same format as old
        // setFlash(form) function
        var flashVersion = swfobject.getFlashPlayerVersion();
        var versionString = flashVersion.major + '.' + flashVersion.minor + ' r' + flashVersion.release;
        $form.find('#PARAM_FLASH_VERSION').val(versionString);

        // get device id from swftopnav element, used to check for known fraud
        // devices
        $form.find('#did').val(security.getDeviceId());

        // block submit if already in progress
        return !submitting;
    }

    function validateFormThroughCaptcha(form) {
		validateCaptchaIfEnabled(form);
    }

	function setDeviceIdSubmitCallBack(form, fingerprint) {
		$ (document.body).css ('cursor', 'progress');
		$(form).find('#deviceIdHashCode').val(generateHashCode(fingerprint));
		$(form).find('#captchaCode').val($.cookie("captcha"));
		$(form).submit();
		submitting = true;
	}

	function generateHashCode(strObject) {
        var strArray = Object.keys(strObject).map(function(e) {
            return strObject[e]
        })
		var strConcat = strArray.join();
		var hash = 0,
			i,
			chr;
		if (strConcat.length === 0) return hash;
		for (i = 0; i < strConcat.length; i++) {
			chr = strConcat.charCodeAt(i);
			hash = (hash << 5) - hash + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

    function submitDone() {
        $(document.body).css('cursor', 'auto');
        submitting = false;
    }

    // toggle label based on if field is empty or not
    function showHideLabel($input) {
        var reqId = $input.attr('id');
        if (reqId === 'loginusername' || reqId === 'loginpassword') {
            var $label = $('label[for="' + $input.attr('id') + '"]');
            if ($input.val().length === 0) {
                $label.css('visibility', 'visible');
            } else {
                $label.css('visibility', 'hidden');
            }
        }
    }


    function setCustomer() {
        try {
            localStorage.setItem('isCustomer', 'true');
        } catch (e) {
        }
    }

    function isCustomer() {
        try {
            return localStorage.getItem('isCustomer');
        } catch (e) {
            return true;
        }
    }

    function showNewPlayerLoginBar() {
        $loginBar.hide();
        nc.show();
    }

    function showLoginBar() {
        $loginBar.css('display', 'inline-block');
        nc.hide();
    }

    function submitFormAfterValidation(form) {
		FSJSC_profile (form, setDeviceIdSubmitCallBack);
	}

    var login = {

        doLogin: doLogin,
        showLoginBar: showLoginBar,
        init: function (form, onSuccess) {
            onSuccess = onSuccess || $.noop;

            var options = {
                dataType: 'json',
                success: ajaxSuccess,
                error: ajaxError,
                beforeSerialize: preProcess
            };

            var $form = $(form);

            if ($form.data('login')) {
                return;
            }

            $form.data('onSuccess', onSuccess);

            if ($playerBar.css('display') === 'none') {
                if (isCustomer()) {
                    showLoginBar();
                } else {
                    showNewPlayerLoginBar();
                }
            }

            $form.data('login', true);

            $form.ajaxForm(options);

            $form.find('.loginbutton').on('click', function (e) {
                e.preventDefault();
                validateFormThroughCaptcha($(this).parents('form:first'));
            });

            $form.find(':text,:password').each(
                function () {
                    var $text = $(this);

                    showHideLabel($text);

                    $text.blur(function () {
                        showHideLabel($(this));
                    });

                    $text.focus(function () {
                        var hideId = $(this).attr('id');
                        if (hideId === 'loginusername' || hideId === 'loginpassword') {
                            var $label = $('label[for="' + $(this).attr('id') + '"]');
                            $label.css('visibility', 'hidden');
                        }
                    });


                    $text.keypress(function (e) {
                        // support enter without having actual submit button
                        // (we use a link, boo)
                        if (e.which === 13) {
                            e.preventDefault();
                            validateFormThroughCaptcha($(this).parents('form:first'));
                        }
                    });
                });

            $('#notmember').on('click', slidingContentWrapper.showSlidingSignup);
            $('#forgot-password').on('click', function() {
                slidingContentWrapper.showSlidingForgottenPassword();
            });
            $('#cnt-newcustomer-bar').find('.links a').on('click', slidingContentWrapper.showSlidingSignup);
            $('#promotion').find('a').on('click', slidingContentWrapper.showSlidingSignup);
        }
    };

    $(function () {
        login.init('#loginhtmlform');
    });

    return login;

});

